import { Modal, Text } from '@ui/themed';
import { t } from 'i18next';
import { useHandlers } from '../../../../context/page-context';
import { useAPISettingsDelete } from '../../hooks/use-api-settings-keys-delete';

export function DeleteConfirmationModal({
  keyData,
  isOpen,
  closeModal,
}: {
  keyData: { name: string; clientId: string } | null;
  isOpen: boolean;
  closeModal: () => void;
}) {
  const { notificationHandler } = useHandlers();

  const {
    mutate: deleteKey,
    reset: deleteReset,
    isPending: deletePending,
  } = useAPISettingsDelete();

  if (!keyData) {
    return null;
  }

  const handleDelete = () => {
    deleteReset();
    deleteKey(keyData.clientId, {
      onSuccess: () => {
        notificationHandler.notify(
          t('notifications:titles.success'),
          t('notifications:deleted'),
          'success',
        );
      },
      onError: () => {
        notificationHandler.notify(t('notifications:titles.error'), t('errors:generic'), 'error');
      },
    });
    closeModal();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={closeModal}
      primaryAction={{
        text: t('features:api_settings.components.modals.delete_confirm.delete'),
        loading: deletePending,
        onClick: handleDelete,
        danger: true,
      }}
      secondaryAction={{
        text: t('buttons:cancel'),
        onClick: closeModal,
      }}
    >
      <Modal.Header>
        {t('features:api_settings.components.modals.delete_confirm.header', {
          keyName: keyData.name,
        })}
      </Modal.Header>
      <Modal.Body>
        <Text variant="secondary">
          {t('features:api_settings.components.modals.delete_confirm.body', {
            keyName: keyData.name,
          })}
        </Text>
      </Modal.Body>
    </Modal>
  );
}
